import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Space,
  Card,
  Layout,
  Form,
  Input,
  Switch,
  Button,
  Table,
  Modal,
  Select,
  message,
  Avatar,
} from "antd";
import {
  AppstoreAddOutlined,
  MenuOutlined,
  UserOutlined,
} from "@ant-design/icons";

import SideBar from "./_sideBar";
import { useParams } from "react-router-dom";
import CopyRight from "./CopyRight";

const { Content } = Layout;
const { Option } = Select;

const SubMerchant = () => {
  const loginUserToken = JSON.parse(localStorage.getItem("loginUserToken"));

  const [menuDisabled, setMenuDisabled] = useState(false);
  const [nextMenuDisabled, setNextMenuDisabled] = useState(false);
  const [subMerchantData, setSubMerchantData] = useState(null);
  const { id } = useParams();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loginUser, setLoginUser] = useState();
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  const [form] = Form.useForm();

  const showModal = () => {
    setIsModalOpen(true);
  };

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("loginUser"));
    setLoginUser(user);
    fetchSubMerchantData();

    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const fetchSubMerchantData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BACKEND_URL}/v1/merchant/findAllSubMerchant/${id}`,
        {
          headers: {
            Authorization: `Bearer ${loginUserToken}`,
          },
        }
      );

      console.log("SUB", response.data);
      
      const processedData = response.data.map((item) => {
        const { subMerchant, user } = item;

        return {
          key: subMerchant.merchantCode,
          merchantID: subMerchant.merchantID,
          name: user?.name,
          username: user?.username,
          callbackUrl: subMerchant.callbackUrl,
          userRole: user?.userRole,
          isEnabled: user?.isEnabled,
        };
      });

      setSubMerchantData(processedData);
    } catch (error) {
      console.error("Error fetching sub-merchant data:", error);
    }
  };

  const handleCreate = async () => {
    setLoading(true); // Set loading to true

    form
      .validateFields()
      .then(async (values) => {
        // Construct subMerchant and user data
        const subMerchantData = {
          name: values.subMerchantName,
          callbackUrl: values.callbackUrl,
          merchantID: id, // Include the merchantId
        };

        const userData = {
          name: values.name,
          username: values.username,
          password: values.password,
          isEnabled: values.isEnabled,
          userRole: values.role,
        };

        // Adjust the structure to match the expected backend format
        const requestData = {
          subMerchant: subMerchantData,
          user: userData,
        };

        try {
          const response = await axios.post(
            `${process.env.REACT_APP_API_BACKEND_URL}/v1/merchant/saveSubMerchant`, // Ensure correct endpoint
            requestData,
            {
              headers: {
                Authorization: `Bearer ${loginUserToken}`,
              },
            }
          );
          if (response.status === 200) {
            // Update submerchant data
            // setSubmerchantData([
            //   ...submerchantData,
            //   { id: Date.now(), ...subMerchantData }, // Add the new submerchant
            // ]);
            fetchSubMerchantData();
            setIsModalOpen(false); // Close the modal
            form.resetFields(); // Reset the form fields
            message.success("Submerchant created successfully!");
          }
        } catch (error) {
          console.error("Error creating sub-merchant:", error);
          message.error("Failed to create submerchant. Please try again.");
        } finally {
          setLoading(false); // Set loading to false after the request
        }
      })
      .catch((info) => {
        console.error("Validation Failed:", info);
        setLoading(false); // Ensure loading is turned off on validation failure
      });
  };

  const submerchantColumns = [
    {
      title: "Merchant ID",
      dataIndex: "merchantID",
      key: "merchantID",
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Username",
      dataIndex: "username",
      key: "username",
    },
    {
      title: "Callback URL",
      dataIndex: "callbackUrl",
      key: "callbackUrl",
    },
    {
      title: "Role",
      dataIndex: "userRole",
      key: "role",
    },
    {
      title: "Enabled",
      dataIndex: "isEnabled",
      key: "iEnabled",
      render: (iEnabled) => (iEnabled ? "Yes" : "No"),
    },
  ];

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <SideBar
        menuDisabled={menuDisabled}
        nextMenuDisabled={nextMenuDisabled}
        fontSize="14px"
        drawerVisibleValue={drawerVisible}
        setDrawerVisibleValue={setDrawerVisible}
      />

      <Layout className="site-layout">
        <Content>
          <div className="site-layout-background" style={{ minHeight: 360 }}>
            <Space
              direction="vertical"
              style={{ padding: "10px", width: "100%" }}
            >
              <Card
                title={
                  <span>
                    {isMobile && (
                      <MenuOutlined
                        onClick={() => setDrawerVisible((prev) => !prev)}
                        style={{ marginRight: 8, fontSize: 30 }}
                      />
                    )}
                    <AppstoreAddOutlined style={{ marginRight: 8 }} />
                    SUBMERCHANTS
                  </span>
                }
                headStyle={{ backgroundColor: "#cccccc" }}
                extra={
                  <span>
                    {loginUser?.username}
                    <Avatar
                      src={loginUser?.avatarUrl}
                      icon={!loginUser?.avatarUrl && <UserOutlined />}
                      style={{ marginLeft: 8 }}
                    />
                  </span>
                }
              >
                <Button
                  type="primary"
                  onClick={showModal}
                  style={{ marginBottom: 16 }}
                >
                  Add New Submerchant
                </Button>
                <Table
                  dataSource={subMerchantData}
                  columns={submerchantColumns}
                  rowKey="id"
                  pagination={{ pageSize: 5 }}
                  bordered
                  scroll={{ x: "max-content" }}
                />
                <Modal
                  title="Add New Submerchant"
                  open={isModalOpen}
                  onOk={handleCreate}
                  okText="Create"
                  cancelText="Cancel"
                  onCancel={() => setIsModalOpen(false)}
                >
                  <Form form={form} layout="vertical">
                    <Form.Item
                      label="Sub Merchant"
                      name="subMerchantName"
                      rules={[
                        {
                          required: true,
                          message: "Please enter SubMerchantName",
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>

                    <Form.Item
                      label="Name"
                      name="name"
                      rules={[
                        { required: true, message: "Please enter the name" },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                    <Form.Item
                      label="Username"
                      name="username"
                      rules={[
                        {
                          required: true,
                          message: "Please enter the username",
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                    <Form.Item
                      label="Password"
                      name="password"
                      rules={[
                        {
                          required: true,
                          message: "Please enter the password",
                        },
                      ]}
                    >
                      <Input.Password />
                    </Form.Item>

                    <Form.Item
                      label="Callback URL"
                      name="callbackUrl"
                      rules={[
                        {
                          required: true,
                          message: "Please enter the callback URL",
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>

                    <Form.Item
                      label="Role"
                      name="role"
                      rules={[
                        { required: true, message: "Please select a role" },
                      ]}
                    >
                      <Select placeholder="Select a role">
                        <Option value="ADMIN">Admin</Option>
                        <Option value="USER">User</Option>
                      </Select>
                    </Form.Item>
                    <Form.Item
                      label="Enabled"
                      name="isEnabled"
                      valuePropName="checked"
                    >
                      <Switch />
                    </Form.Item>
                  </Form>
                </Modal>
              </Card>
            </Space>
          </div>
          <CopyRight />
        </Content>
      </Layout>
    </Layout>
  );
};

export default SubMerchant;
